import { useBrandContext } from './brandShared';
import { SECTION_LABELS } from '../../hooks/brand/useBrandForm';
import { Modal, ModalActions } from '../Modal';
import { Button } from '../Button';
import { Input, Label, ErrorMessage } from '../Input';

/**
 * Modal de auto-relleno con IA. Lo dispara cualquier tab vía form.openAiFill(section)
 * y se renderiza UNA vez en BrandPage (consume el estado del hook por contexto).
 * El usuario pega 1+ URLs; la IA lee y rellena esa sección (merge, no auto-save).
 */
export function BrandAiFillModal() {
  const { form } = useBrandContext();
  const section = form.aiSection;
  if (!section) return null;

  return (
    <Modal
      isOpen={section !== null}
      onClose={form.closeAiFill}
      title={`✨ Auto-fill · ${SECTION_LABELS[section]}`}
      maxWidth="480px"
    >
      <p style={{ fontSize: 13, lineHeight: 1.5, color: '#64748B', marginBottom: 14 }}>
        Paste one or more links (your website, About page, socials). The AI reads them and
        fills this section. Review the result, then <strong>Save</strong> to keep it.
      </p>

      <Label>Sources (URLs)</Label>
      {form.aiSources.map((src, i) => (
        <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <Input
            type="url"
            value={src}
            onChange={(e) => form.updateAiSource(i, e.target.value)}
            placeholder="https://example.com/about"
            disabled={form.aiBusy}
            autoFocus={i === 0}
          />
          {form.aiSources.length > 1 && (
            <Button
              type="button"
              $variant="outline"
              $size="sm"
              onClick={() => form.removeAiSource(i)}
              disabled={form.aiBusy}
              aria-label="Remove source"
            >
              <span aria-hidden="true">×</span>
            </Button>
          )}
        </div>
      ))}

      <Button type="button" $variant="ghost" $size="sm" onClick={form.addAiSource} disabled={form.aiBusy}>
        + Add another URL
      </Button>

      {form.aiError && <ErrorMessage style={{ marginTop: 10 }}>{form.aiError}</ErrorMessage>}

      <ModalActions>
        <Button type="button" $variant="outline" onClick={form.closeAiFill} disabled={form.aiBusy}>
          Cancel
        </Button>
        <Button type="button" onClick={() => void form.runAiFill()} disabled={form.aiBusy}>
          {form.aiBusy ? '✨ Searching…' : '✨ Search with AI'}
        </Button>
      </ModalActions>
    </Modal>
  );
}
